import type { ComponentThemeStyles } from './types';

export const minimalTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'IBM Plex Sans, system-ui, sans-serif',
    bodyFont: 'IBM Plex Sans, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-transparent',
    text: 'text-gray-900',
    brandText: 'text-gray-900',
    linkText: 'text-gray-700',
    linkHover: 'hover:text-primary-600',
    border: 'border-b border-gray-200',
    shadow: '',
    height: 'h-16',
  },
  navigationMenu: {
    background: 'bg-transparent',
    text: 'text-gray-900',
    brandText: 'text-gray-900',
    linkText: 'text-gray-700',
    linkHover: 'hover:text-primary-600',
    border: 'border-b border-gray-200',
    shadow: '',
    height: 'h-16',
    dropdownBackground: 'bg-white',
    dropdownText: 'text-gray-700',
    dropdownHover: 'hover:bg-gray-50',
  },
  hero: {
    background: 'bg-white',
    text: 'text-gray-900',
    buttonStyle: 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white',
    pattern: false,
  },
  splitHero: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#111827',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#111827',
    buttonBg: '#111827',
    buttonText: '#ffffff',
    buttonHover: '#374151',
  },
  simpleHeader: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
  },
  features: {
    background: 'bg-white',
    cardBg: 'bg-transparent',
    iconColor: 'text-gray-900',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-600',
    borderRadius: '',
  },
  footer: {
    background: 'bg-white',
    text: 'text-gray-900',
    mutedText: 'text-gray-500',
    border: 'border-t border-gray-200',
  },
  cta: {
    background: 'bg-white',
    text: 'text-gray-900',
    buttonStyle: 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white',
  },
  form: {
    background: 'bg-white',
    inputBg: 'bg-transparent',
    inputBorder: 'border-gray-900',
    inputText: 'text-gray-900',
    labelColor: 'text-gray-900',
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
  },
  pricing: {
    background: 'bg-white',
    cardBg: 'bg-transparent border border-gray-900',
    highlightedCard: 'bg-gray-900 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-gray-700',
    descriptionColor: 'text-gray-600',
    planTitle: 'text-gray-900',
    planDescription: 'text-gray-600',
    priceColor: 'text-gray-900',
    periodColor: 'text-gray-600',
    featureColor: 'text-gray-700',
    checkColor: '#111827',
    highlightedTitle: 'text-white',
    highlightText: '#111827',
    highlightedDescription: 'text-gray-300',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-gray-300',
    highlightedFeature: 'text-gray-200',
    highlightedCheckColor: '#ffffff',
    borderColor: 'border-gray-900',
    highlightBorder: 'border-gray-900',
    highlightRing: 'ring-gray-900',
    hoverGlow: '',
    badgeBg: '#111827',
    badgeText: 'white',
    buttonBg: '#111827',
    highlightedButtonBg: '#ffffff',
  },
  mediaText: {
    background: '#ffffff',
    titleColor: '#111827',
    textColor: '#4b5563',
    accentColor: '#111827',
  },
  faq: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    questionColor: '#111827',
    answerColor: '#4b5563',
    itemBackground: '#ffffff',
    itemBorder: '#111827',
    iconColor: '#111827',
  },
  testimonials: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    cardBackground: '#ffffff',
    cardBorder: '#111827',
    quoteColor: '#4b5563',
    nameColor: '#111827',
    roleColor: '#6b7280',
    starColor: '#111827',
  },
  countdownTimer: {
    background: '#ffffff',
    text: '#111827',
    headline: '#111827',
    subheadline: '#6b7280',
    number: '#111827',
    label: '#6b7280',
  },
  imageGallery: {
    background: '#ffffff',
    text: '#111827',
    title: '#111827',
    subtitle: '#6b7280',
    caption: '#4b5563',
    filterButton: '#f9fafb',
    filterButtonActive: '#111827',
  },
  imageInfo: {
    background: '#ffffff',
    text: '#111827',
    title: '#111827',
    subtitle: '#6b7280',
    imageBorder: '#f9fafb',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: '#ffffff',
    overlayColor: '#000000',
    title: '#ffffff',
    description: '#e5e7eb',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  team: {
    background: '#ffffff',
    cardBg: '#ffffff',
    nameColor: '#111827',
    roleColor: '#6b7280',
    borderColor: '#111827',
  },
  video: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    textColor: '#4b5563',
  },
  textBlocks: {
    background: '#ffffff',
    titleColor: '#111827',
    textColor: '#4b5563',
    linkColor: '#111827',
  },
  titleSubtitle: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    buttonBg: '#111827',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: '#ffffff',
    titleColor: '#111827',
    textColor: '#4b5563',
    accentColor: '#111827',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#ffffff',
  },
  promoBanner: {
    background: '#111827',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
  },
  stats: {
    background: '#ffffff',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    valueColor: '#111827',
    labelColor: '#374151',
    descriptionColor: '#6b7280',
  },
  blogPreview: {
    background: '#f9fafb',
    titleColor: '#111827',
    subtitleColor: '#6b7280',
    cardBackground: '#ffffff',
    cardTitle: '#111827',
    cardExcerpt: '#4b5563',
    linkColor: '#3b82f6',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.55)',
    panelBackground: '#ffffff',
    headlineColor: '#111827',
    bodyTextColor: '#374151',
    buttonBackground: '#111827',
    buttonText: '#ffffff',
    closeButton: '#6b7280',
  },
  blog: {
    pageBackground: '#ffffff',
    headerBackground: '#ffffff',
    titleColor: '#111827',
    descriptionColor: '#6b7280',
    textColor: '#4b5563',
    mutedTextColor: '#9ca3af',
    linkColor: '#111827',
    linkHoverColor: '#374151',
    cardBackground: '#ffffff',
    cardBorder: '#111827',
    cardShadow: 'none',
    cardHoverShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    postTitleColor: '#111827',
    postTextColor: '#4b5563',
    postMetaColor: '#6b7280',
    tagBackground: '#ffffff',
    tagText: '#111827',
    tagActiveBackground: '#111827',
    tagActiveText: '#ffffff',
    sidebarBackground: '#ffffff',
    sidebarTitleColor: '#111827',
    paginationBackground: '#ffffff',
    paginationText: '#111827',
    paginationBorder: '#111827',
    paginationActiveBackground: '#111827',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#6b7280',
    loadingSpinnerColor: '#111827',
    errorIconColor: '#9ca3af',
    errorButtonBackground: '#111827',
    errorButtonText: '#ffffff',
  },
};
